<template>
  <div class="about">
      <!-- 第一部分 -->
      <div class="about_1 pd_b20 txt_c">
          <p class="color_fff about_1_title">关于我们</p>
          <div class="about_1_content">
            <p class="color_fff txt_l">量势（控股）深圳有限公司，创立于2011年，总部设在深圳万科星火online，互联网技术团队设于深圳万科星火online，设有深圳量势、广州嘉势、广州量智、海南海口、海南儋州、广东佛山和武汉等子公司，专注于电动汽车商用充电领域。</p>
          </div>
      </div>
      <!-- 第二部分 -->
      <div class="about_2 pd_b20 txt_c">
        <p class="color_fff about_1_title">核心团队</p>
        <div class="about_1_content">
            <p class="color_fff txt_l">创始人来自世界500强电气巨头ABB高管；互联网团队带头人和主要成员来自腾讯技术和商务高管；充电运营团队均出自世界500强知名企业，拥有多年充电运营实际操作经验，坚守充电产品安全和品质控制，按照长远布局和逐步系统性优化产品各个链条和环节思维扎根充电行业； 多位同事出自清华、北大、南开、西安交大等知名院校。</p>
          </div>
      </div>
      <!-- 第三部分 -->
      <div class="about_3 pd_b20">
        <div class="clear_fd">
          <div class="ft_l about_3_top_l">产品范围</div>
          <div class="txt_r ft_r about_3_top_r color_666">
            <p>公交车、商务大巴、出租车、网约车、物流车、环卫物流车和电动渣土车等</p>
            <p>充电桩、充电站运营云平台</p>
          </div>
        </div>
        <div class="clear_fd about_3_bottom">
          <div class="tu_wen ft_l about_3_li">
            <img src="../assets/about/about_fw_1.png" alt="" class="about_3_img">
            <span>电动物流车</span>
          </div>
          <div class="ft_l about_3_li wid34 pr10 pl10">
            <div class="tu_wen">
              <img src="../assets/about/about_fw_2.png" alt="" class="about_3_img">
              <span>大巴、公交车</span>
            </div>
            <div class="tu_wen mt25">
              <img src="../assets/about/about_fw_3.png" alt="" class="about_3_img">
              <span>乘用车等充电桩</span>
            </div>
          </div>
          <div class="tu_wen ft_r about_3_li">
            <img src="../assets/about/about_fw_4.png" alt="" class="about_3_img">
            <span>充电站运营云平台</span>
          </div>
        </div>
      </div>
      <!-- 第四部分 -->
      <div class="about_4 pd_b20">
        <div class="about_4_content">
          <div class="about_4_content_txt1 color_fff">产品使用经验</div>
          <div class="about_4_content_txt2 color_fff">
            <p>在深圳、广州、海口、三亚、惠州、成都、贵阳、佛山、东莞、儋州</p>
            <p class="mt5">和京东物流、公交集团、奔驰比亚迪等客户高强度的实际使用和磨合</p>
          </div>
          <div class="about_cn_bg">
            <img src="../assets/about/about_cn.png" alt="">
            <div class="about_cn_li guiyang color_fff txt_r"><span class="about_cn_li_md fz_14 mr5">贵阳</span><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span></div>
            <div class="about_cn_li guangzhou color_fff txt_r"><span class="about_cn_li_md fz_14 mr5">广州</span><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span></div>
            <div class="about_cn_li foshan color_fff txt_r"><span class="about_cn_li_md fz_14 mr5">佛山</span><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span></div>
            <div class="about_cn_li danzhou color_fff txt_r"><span class="about_cn_li_md fz_14 mr5">儋州</span><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span></div>
            <div class="about_cn_li chongqing color_fff txt_r"><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span><span class="about_cn_li_md fz_14 ml5">重庆</span></div>
            <div class="about_cn_li haikou color_fff txt_r"><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span><span class="about_cn_li_md fz_14 ml5">海口</span></div>
            <div class="about_cn_li shenzhen color_fff txt_r"><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span><span class="about_cn_li_md fz_14 ml5">深圳</span></div>
            <div class="about_cn_li dongguan color_fff txt_r"><span :class="'about_cn_dz about_cn_li_md '+(shad ? 'br_shad_show' : 'br_shad_hide')"></span><span class="about_cn_li_md fz_14 ml5">东莞</span></div>
          </div>
        </div>
      </div>
      <!-- 第五部分 -->
      <div class="about_5 pd_b20">
        <div class="about_5_content">
          <div class="about_5_content_txt txt_r color_fff">
            <p class="about_5_content_txt_1">互联网云平台</p>
            <p class="about_5_content_txt_2 mt40">通过和京东电动物流车的实际使用和反复磨合，研发使用的</p>
            <p class="about_5_content_txt_2 mt5">互联网运营云平台经过多轮迭代，为目前国内物流充电细分领域的标杆</p>
          </div>
        </div>
      </div>
      <!-- 第六部分 -->
      <div class="about_6 pd_b20">
        <p class="about_6_txt color_333 txt_c">主要客户</p>
        <div class="about_6_ul clear_fd mt50 pt10">
          <div class="about_6_li mr_b2"><img src="../assets/about/about_kh_1.png" alt="" class="about_6_li_img"></div>
          <div class="about_6_li mr_b2"><img src="../assets/about/about_kh_2.png" alt="" class="about_6_li_img"></div>
          <div class="about_6_li mr_b2"><img src="../assets/about/about_kh_3.png" alt="" class="about_6_li_img"></div>
          <div class="about_6_li mr_b2"><img src="../assets/about/about_kh_4.png" alt="" class="about_6_li_img"></div>
          <div class="about_6_li mr_b2"><img src="../assets/about/about_kh_5.png" alt="" class="about_6_li_img"></div>
          <div class="about_6_li"><img src="../assets/about/about_kh_6.png" alt="" class="about_6_li_img"></div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shad: true
    };
  },
  created() {
    var that = this;
    setInterval(function() {
      that.shad = !that.shad;
    }, 500);
  }
};
</script>

<style>
.tu_wen {
  position: relative;
}
.tu_wen span {
  position: absolute;
  bottom: 20px;
  right: 12px;
  color: #ffffff;
  z-index: 2;
}
.tu_wen::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

/* 第一部分样式 */
.about_1 {
  background-image: url("../assets/about/about_bg_1.png");
  background-size: 100% 100%;
  height: 698px;
  padding-top: 250px;
}
.about_1_title {
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 10px;
}
.about_1_content {
  width: 88%;
  margin: 40px auto;
  font-size: 22px;
  line-height: 38px;
}

/* 第二部分样式 */
.about_2 {
  height: 420px;
  background-image: url("../assets/about/about_bg_2.png");
  background-size: 100% 100%;
  padding-top: 88px;
}
/* 第三部分样式 */
.about_3 {
  padding-top: 76px;
  padding-bottom: 50px;
}
.about_3_top_l {
  font-size: 34px;
  color: #444444;
  font-weight: bold;
  margin-top: 20px;
}
.about_3_top_r {
  font-size: 24px;
  line-height: 39px;
}
.about_3_bottom {
  margin-top: 80px;
}
.about_3_li {
  width: 33%;
  box-sizing: border-box;
}
.wid34 {
  width: 34%;
}
.about_3_img {
  width: 100%;
}

/* 第四部分样式 */
.about_4 {
  height: 620px;
  background-image: url("../assets/about/about_bg_4.png");
  background-size: 100% 100%;
}
.about_4_content {
  height: 100%;
  position: relative;
}
.about_cn_bg {
  position: absolute;
  width: 60%;
  right: 0;
  top: 33px;
}
.about_cn_bg img {
  width: 100%;
}

.about_cn_li_md {
  vertical-align: middle;
}
.about_cn_dz {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
}
.br_shad_show {
  box-shadow: 0 0 0px 5px #5e9eb0;
  animation: shad-show 0.5s linear;
}
.br_shad_hide {
  box-shadow: 0 0 0px 0px #5e9eb0;
  animation: shad-hide 0.5s linear;
}
@keyframes shad-show {
  0% {
    box-shadow: 0 0 0 0px #5e9eb0;
  }
  100% {
    box-shadow: 0 0 0px 5px #5e9eb0;
  }
}
@keyframes shad-hide {
  0% {
    box-shadow: 0 0 0px 5px #5e9eb0;
  }
  100% {
    box-shadow: 0 0 0 0px #5e9eb0;
  }
}
.guiyang {
  position: absolute;
  bottom: 150px;
  right: 206px;
}
.chongqing {
  position: absolute;
  bottom: 214px;
  right: 222px;
}
.haikou {
  position: absolute;
  bottom: 65px;
  right: 167px;
}
.guangzhou {
  position: absolute;
  bottom: 124px;
  right: 134px;
}
.shenzhen {
  position: absolute;
  bottom: 104px;
  right: 100px;
}
.foshan {
  position: absolute;
  bottom: 106px;
  right: 155px;
}
.dongguan {
  position: absolute;
  bottom: 118px;
  right: 94px;
}
.danzhou {
  position: absolute;
  bottom: 60px;
  right: 212px;
}

.about_4_content_txt1 {
  font-size: 34px;
  font-weight: bold;
  padding: 92px 0;
  position: absolute;
  top: 0;
}
.about_4_content_txt2 {
  padding: 72px 0;
  font-size: 18px;
  position: absolute;
  bottom: 0;
}
/* 第五部分样式 */
.about_5 {
  height: 678px;
  background-image: url("../assets/about/about_bg_5.png");
  background-size: 100% 100%;
  position: relative;
}
.about_5::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.about_5_content {
  position: relative;
}
.about_5_content_txt {
  width: 100%;
  position: absolute;
  z-index: 2;
  top: 155px;
}
.about_5_content_txt_1 {
  font-weight: bold;
  font-size: 34px;
}
.about_5_content_txt_2 {
  font-size: 24px;
}
/* 第六部分样式  */
.about_6 {
  height: 326px;
  padding-top: 60px;
}
.about_6_txt {
  font-size: 34px;
  font-weight: bold;
}
.about_6_li {
  float: left;
  width: 15%;
}
.mr_b2 {
  margin-right: 2%;
}
.about_6_li_img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue